import { PortalStyleConfig } from '@nx-frontend/shared/types';

export const webnotesThemeStyle: PortalStyleConfig = {
  radius: {
    className: ['rounded-lg'],
  },
  border: {
    className: ['border'],
  },
  shadow: {
    className: ['shadow-lg'],
  },
};
